import { Button, ButtonsGroup } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import type { EditManualBankAccountFormApi } from '../../hooks/useEditManualBankAccountForm'

interface EditManualBankAccountFormFooterProps {
  form: EditManualBankAccountFormApi
}

export const EditManualBankAccountFormFooter = ({
  form: { closeModal, isProcessing, saveButtonTKey, submitForm },
}: EditManualBankAccountFormFooterProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <ButtonsGroup>
      <Button onClick={closeModal} variant="text">
        {t('cancel')}
      </Button>
      <Button loading={isProcessing} onClick={submitForm}>
        {t(saveButtonTKey)}
      </Button>
    </ButtonsGroup>
  )
}
